const q = () => new URLSearchParams(window.location.search).get("site");

export function isDataSite() {
  if (typeof window === "undefined") return false;
  const v = q();
  if (v === "data") sessionStorage.setItem("vdr_site", "data");
  if (v === "main") sessionStorage.removeItem("vdr_site");
  // one-time cleanup: older builds persisted the imprint forever in localStorage
  localStorage.removeItem("vdr_site");
  const h = window.location.hostname;
  if (h === "virtusdata.com" || h === "www.virtusdata.com" || h.startsWith("data.")) return true;
  return sessionStorage.getItem("vdr_site") === "data";
}

const onProdHost = () => /virturegistry\.com|virtusdata\.com/.test(window.location.hostname);

export const dataSiteHref = (path = "/") =>
  onProdHost() ? `https://data.virturegistry.com${path}` : `${path}?site=data`;

export const mainSiteHref = (path = "/") =>
  onProdHost() ? `https://virturegistry.com${path}` : `${path}?site=main`;

export const goSite = (href) => window.location.assign(href);
